import React from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-bootstrap'
import { ReactComponent as IconEdit } from 'assets/icons/edit.svg'
import { ReactComponent as IconCheck } from 'assets/icons/check.svg'
import { ReactComponent as IconDelete } from 'assets/icons/delete.svg'
import { ReactComponent as IconChevron } from 'assets/icons/dropdown.svg'

import moment from 'moment'

import TouchableOpacity from 'components/TouchableOpacity'

const formatSessionDate = value => {
  if (!value) return ''
  if (
    typeof value === 'string' &&
    /[A-Za-z]{3,}\s+\d{1,2},\s+\d{4}/.test(value)
  ) {
    return value
  }

  const m = moment.utc(value)
  if (!m.isValid()) return String(value)
  return m.format('MMM DD, YYYY')
}

const CollabSessionCollapseHeader = ({
  title,
  isOpen,
  isEditing,
  date,
  toggle,
  onToggleEditing,
  onDelete
}) => {
  return (
    <>
      <Col xs={8} className="font-weight-medium pl-0">
        <TouchableOpacity
          onClick={toggle}
          className="w-100"
          style={{ display: 'block' }}
        >
          <div
            className="d-flex align-items-center"
            style={{ gap: 8 }}
          >
            <IconChevron
              style={{
                width: 14,
                height: 14,
                transform: isOpen
                  ? 'rotate(0deg)'
                  : 'rotate(180deg)'
              }}
            />
            <div style={{ flex: '0 1 auto', fontSize: 18 }}>
              {title}
            </div>
            <div style={{ flex: 1 }} />
          </div>
        </TouchableOpacity>

        <div className="text-gray-dark mr-20 d-md-none">
          {formatSessionDate(date)}
        </div>
      </Col>

      <Col
        xs={4}
        className="d-flex justify-content-end align-items-center pr-0"
      >
        <div className="text-gray-dark mr-20 d-none d-md-block">
          {formatSessionDate(date)}
        </div>

        {typeof onToggleEditing === 'function' ? (
          <TouchableOpacity
            onClick={onToggleEditing}
            className="mr-10"
            title={isEditing ? 'Done editing' : 'Edit'}
          >
            {isEditing ? <IconCheck /> : <IconEdit />}
          </TouchableOpacity>
        ) : null}

        {typeof onDelete === 'function' ? (
          <TouchableOpacity
            onClick={onDelete}
            className="mr-10"
            title="Delete"
          >
            <IconDelete />
          </TouchableOpacity>
        ) : null}
      </Col>
    </>
  )
}

CollabSessionCollapseHeader.propTypes = {
  title: PropTypes.string,
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  isOpen: PropTypes.bool,
  isEditing: PropTypes.bool,
  toggle: PropTypes.func,
  onToggleEditing: PropTypes.func,
  onDelete: PropTypes.func
}

CollabSessionCollapseHeader.defaultProps = {
  title: '',
  date: '',
  isOpen: false,
  isEditing: false,
  toggle: null,
  onToggleEditing: null,
  onDelete: null
}

export default CollabSessionCollapseHeader
